import { Box } from "@mui/material"
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { svSE } from '@mui/x-data-grid/locales';

import { StarredField } from "./ColumnCells/StarredField";
import { OpenSessionField } from "./ColumnCells/OpenSessionField";
import { StatusField } from "./ColumnCells/StatusField";
import { RemoveSessionField } from "./ColumnCells/RemoveSessionField";
import { SessionsCustomToolbar } from "./gridCustomToolbar";
import { useEffect, useMemo, useState } from "react";
import { SessionParamsEnum } from "../../../enums";
import { useSessionParams } from "../../../contexts";
import { SessionTreeField } from "./ColumnCells/SessionTreeField";
import { useContextAuth } from "../../../authContext/AuthHook";

/**
 * 
 * @param {Object} param0 
 * @param {Array} param0.sessions
 * @param {Boolean} param0.notInSession
 * @returns 
 */
export const AllSessionsComponent = ({ sessions, notInSession }) => {
    const columns = [
        {
            field: 'starred',
            headerName: 'Stjärnmärkt',
            sortable: false,
            width: 30,
            renderCell: StarredField,
            renderHeader: () => (
                <div></div>
            ),
        },
        {
            field: 'id',
            headerName: 'Sessions ID',
            width: 130,
        },
        {
            field: 'sessionTree',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 30,
            renderCell: ({ row }) => SessionTreeField({ row })
        },
        {
            field: 'anläggning',
            headerName: 'Anläggning',
            width: 150,
        },
        {
            field: 'projNr',
            headerName: 'Projekt Nr',
            width: 110,
        },
        {
            field: 'numShunts',
            headerName: 'Antal positioner',
            sortable: false,
            width: 160,
            valueGetter: (value, row) => `${Object.keys(row?.SessionShunts || {}).length}`,
        },
        {
            field: 'options',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 80,
            renderCell: ({ value, row }) => OpenSessionField({ value, row, notInSession })
        },
        {
            field: 'statusTestSession',
            headerName: 'Test-Session',
            sortable: false,
            width: 80,
            renderCell: ({ row }) => StatusField({ row })
        },
        {
            field: 'removeSession',
            headerName: '',
            width: 60,
            renderCell: ({ row }) => RemoveSessionField({ row })
        },
    ];
    const { user } = useContextAuth();
    const sessionParams = useSessionParams();
    const [showTest, setShowTest] = useState(false);
    const [showDeleted, setShowDeleted] = useState(false);

    useEffect(() => {
        if (user?.isDev === true){
            setShowTest(true);
        }
    }, [user]);

    const handleChangeShowTest = () => {
        setShowTest((val) => !val);
    }

    const handleChangeShowDeleted = () => {
        setShowDeleted((val) => !val);
    }

    //console.log("Sessions: ", sessions)

    const filteredSessions = useMemo(() => {
        if (showTest === true) {
            return sessions.filter((item) => (item?.status !== 'removed' || showDeleted === true))
        }
        else {
            return sessions.filter((item) => (item?.status !== 'test' && (item?.status !== 'removed' || showDeleted === true)) || item?.id === SessionParamsEnum.SessionID.getContextValue(sessionParams))
        }
    }, [sessions, showTest, showDeleted]);

    return (
        <Box>
            <DataGrid
                sx={{ minHeight: '200px' }}
                density="compact"
                rows={filteredSessions}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 15,
                        },
                    },
                    sorting: {
                        sortModel: [{ field: 'id', sort: 'desc' }]
                    },
                }}
                slots={{ toolbar: () => SessionsCustomToolbar(showTest, handleChangeShowTest, showDeleted, handleChangeShowDeleted, user?.isDev === true) }}
                disableColumnSelector
                disableDensitySelector
                slotProps={{
                    toolbar: {
                        csvOptions: { disableToolbarButton: true },
                        printOptions: { disableToolbarButton: true },
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 250 },
                    },
                    footerRowCount: {

                    }
                }}
                pageSizeOptions={[10, 15, 25, 50]}
                disableRowSelectionOnClick
                localeText={svSE.components.MuiDataGrid.defaultProps.localeText}
            />
        </Box>
    )
}